import React, { Component } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
// import Constants from "../App/Variables/Constants";
import {
  Backdrop,
  Button,
  Container,
  Fade,
  Grid,
  Box,
  //   GridItem,
  Modal,
  TextField,
  Typography,
  Snackbar,
  //   InputLabel,
  //   Select,
  //   MenuItem,
} from "@material-ui/core";
import init from "../helpers/WindowToken";
import Constants from "../App/Variables/Constants";
import EditIcon from "@material-ui/icons/Edit";
import { Link } from "react-router-dom";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { makeStyles } from "@material-ui/core";

const classes = makeStyles();

export default class UpdateVariants extends Component {
  state = {
    notification: false,
    redirect: false,
    loading: false,
    product_id: "",
    size: "",
    colour: "",
    price: 0,
    quantity: 0,
    delivery_charge: "",
    images: [],
    _id: "",
    offer_price: 0,
    imageSelectd: [],
    UpdateBySize: "",
  };

  componentDidMount() {
    this.setState({ _id: window.location.pathname.split("/")[3] }, () => {
      this.getSingleVariant();
    });
  }

  getSingleVariant = () => {
    axios
      .get(Constants.getUrls.getAllVariants + "/" + this.state._id)
      .then((resp) => {
        this.setState({
          product_id: resp.data.data.product_id,
          size: resp.data.data.size,
          colour: resp.data.data.colour,
          price: resp.data.data.price,
          quantity: resp.data.data.quantity,
          delivery_charge: resp.data.data.delivery_charge,
          images: resp.data.data.images,
          offer_price: resp.data.data?.offer_price,
        });
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData();

    fd.append("size", this.state.size);
    fd.append("colour", this.state.colour);
    fd.append("price", this.state.price);
    fd.append("quantity", this.state.quantity);
    fd.append("product_id", this.state.product_id);
    fd.append("offer_price", this.state.offer_price);
    fd.append("delivery_charge", this.state.delivery_charge);
    if (this.state.imageSelectd.length > 0) {
      for (let i = 0; i <= this.state.imageSelectd.length - 1; i++) {
        fd.append("images", this.state.imageSelectd[i]);
      }
    }

    this.setState({
      loading: true,
    });
    if (init() === "success") {
      axios
        .put(Constants.putUrls.updateVariants + "/" + this.state._id, fd)
        .then((resp) => {
          // console.log(resp);
          fd.delete("category");
          this.setState({
            loading: false,
            notification: true,
            message: resp.data.message,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              redirect: true,
            });
          }, 1500);
        })
        .catch((error) => {
          fd.delete("category");
          this.setState({
            notification: true,
            message: error.response.data.message,
          });
          // console.log(error.response.data.message);
          setTimeout(() => {
            this.setState({
              notification: false,
              redirect: false,
              loading: false,
            });
          }, 1500);
        });
    }
  };

  UpdateBySize = () => {
    const fd = new FormData();

    fd.append("size", this.state.size);
    fd.append("colour", this.state.colour);
    fd.append("price", this.state.price);
    fd.append("quantity", this.state.quantity);
    fd.append("product_id", this.state.product_id);
    fd.append("offer_price", this.state.offer_price);
    fd.append("delivery_charge", this.state.delivery_charge);

    if (this.state.imageSelectd.length > 0) {
      for (let i = 0; i < this.state.imageSelectd.length; i++) {
        fd.append("images", this.state.imageSelectd[i]);
      }
    }

    // Confirmation
    if (!window.confirm(`Update all ${this.state.size} size variants?`)) {
      return;
    }

    this.setState({ loading: true });

    axios
      .put(Constants.putUrls.updateVariantsBySize, fd)
      .then((resp) => {
        this.setState({
          loading: false,
          notification: true,
          message: resp.data.message,
        });

        setTimeout(() => {
          this.setState({
            notification: false,
            redirect: true,
          });
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          notification: true,
          message: error?.response?.data?.message || "Something went wrong",
        });

        setTimeout(() => {
          this.setState({
            notification: false,
          });
        }, 1500);
      });
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleFile = (e) => {
    console.log(e.target.files);
    this.setState({
      [e.target.name]: e.target.files,
    });
  };
  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: "/admin/variants/" + this.state.product_id,
          }}
        />
      );
    } else {
      return (
        <Container maxWidth="xl">
          <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
            <Grid item xs={6}>
              <Typography variant="h5"> Update Variant </Typography>
            </Grid>
          </Grid>

          {/* After Getting api add Snackbar notification here  */}
          {this.state.notification ? (
            <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={true}
              color={"s"}
              autoHideDuration={6000}
              message={this.state.message}
            ></Snackbar>
          ) : null}

          <div
            style={{
              background: "#5b5757",
              padding: "20px",
              borderRadius: "10px",
              width: "100%",
              border: "0",
              display: "flex",
              position: "relative",
              fontSize: ".875rem",
              minWidth: "0",
              wordWrap: " break-word",
              boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
              marginTop: "30px",
              borderRadius: "6px",
              marginBottom: "30px",
              flexDirection: "column",
              textAlign: "left",
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250)) rgb(153, 153, 153))",
                boxShadow:
                  " rgb(0 0 0 / 14%) 0px 4px 20px 0px, rgb(128 120 120 1/ 40%) 0px 7px 10px -5px",
                float: "left",
                padding: "15px",
                marginTop: "-43px",
                marginRight: "15px",
                borderRadius: "3px",
                backgroundColor: "#999",
                width: "6%",
                height: "60px",
                marginBottom: "25px",
                textAlign: "center",
              }}
            >
              <EditIcon />
            </div>

            <form onSubmit={this.handleSubmit}>
              <Grid container sm={12} spacing={2}>
                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Size"
                    name="size"
                    variant="outlined"
                    required={true}
                    value={this.state.size}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Colour"
                    name="colour"
                    variant="outlined"
                    required={true}
                    value={this.state.colour}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>
                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Price"
                    name="price"
                    variant="outlined"
                    required={true}
                    value={this.state.price}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>
                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Offer Price"
                    name="offer_price"
                    variant="outlined"
                    // required={true}
                    value={this.state.offer_price}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>
                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Quantity"
                    name="quantity"
                    variant="outlined"
                    required={true}
                    value={this.state.quantity}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Delivery Charges"
                    name="delivery_charge"
                    variant="outlined"
                    required={true}
                    value={this.state.delivery_charge}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>

                <Grid item sm={4}>
                  <label> Select Images (Maximum 4) </label>
                  <input
                    type="file"
                    name="imageSelectd"
                    multiple
                    onChange={this.handleFile}
                    // required
                  />
                </Grid>
              </Grid>

              <Grid item sm={12}>
                <Typography variant="subtitle1" style={{ marginTop: "10px" }}>
                  Existing Images
                </Typography>

                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  {this.state.images && this.state.images.length > 0 ? (
                    this.state.images.map((img, index) => (
                      <img
                        key={index}
                        src={Constants.imgDomain + img}
                        alt="variant"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "6px",
                          border: "1px solid #ddd",
                        }}
                      />
                    ))
                  ) : (
                    <p>No images found</p>
                  )}
                </div>
              </Grid>

              <br />
              <div>
                <Button
                  variant="contained"
                  type="submit"
                  size="small"
                  color="primary"
                  style={{
                    marginRight: "20px",

                    marginTop: "35px",
                  }}
                >
                  {this.state.loading ? "Adding.." : "Update"}
                </Button>
                <Link
                  to={{
                    pathname: "/admin/variants/" + this.state.product_id,
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    size="small"
                    color="secondary"
                    style={{ marginRight: "20px", marginTop: "35px" }}
                  >
                    Cancel
                  </Button>
                </Link>
                <Button
                  variant="contained"
                  type="button"
                  size="small"
                  color="primary"
                  style={{
                    marginRight: "20px",
                    marginTop: "35px",
                  }}
                  onClick={this.UpdateBySize}
                  disabled={this.state.loading}
                >
                  {this.state.loading
                    ? "Updating..."
                    : `Update All Size ${this.state.size} Entries`}
                </Button>
              </div>
            </form>
          </div>
        </Container>
      );
    }
  }
}
